export default __webpack_public_path__ + "static/media/profile.298cea56.jpg";